import { LookupModelSearchEvent } from "@mcleod/components";
import { AutogenLayoutSuggestedCallReport } from "./autogen/AutogenLayoutSuggestedCallReport"

export class SuggestedCallReport extends AutogenLayoutSuggestedCallReport {
    private _assignedUser = "Assigned CSRs";
    private _operationUser = "Operations Users";

    onLoad() {
        this.excludabletextboxAssignUsers.textbox.caption = this._assignedUser;
    }

    switchSourceOnChange(){
        const isChecked = this.switchSource.checked;
        this.excludabletextboxAssignUsers.textbox.caption = isChecked ? this._assignedUser : this._operationUser;
    }

    textboxAssignUsersBeforeLookupMode(event: LookupModelSearchEvent) {
        event.filter.web_user_type = "U || E"
    }

}
